import * as React from "react";

// Types
import Statement from "../types/Statement.interface";

// Misc.
import { useConditionState } from "../context/Condition.context";
import conditionReducer from "./Condition.lib";

const useCondition = (statement: Statement): [boolean] => {
  const [showStatement, setShowStatement] = React.useState(false);
  const conditionState = useConditionState();

  React.useEffect(() => {
    const { conditions } = statement;

    if (conditions && conditions.length > 0) {
      const conditionCheckPassed = conditionReducer(conditions, conditionState);
      setShowStatement(conditionCheckPassed);
    } else {
      setShowStatement(true);
    }
  }, [conditionState, statement]);

  return [showStatement];
};

export default useCondition;
